import { render, staticRenderFns } from "./WebPartFormLinkRunner.vue?vue&type=template&id=2f885892&"
import script from "./WebPartFormLinkRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormLinkRunner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports